import { http } from '@/providers/apis/http';
import { collectionSerializer } from '@/providers/serializers/content/collection';
import { lessonSerializer } from '@/providers/serializers/content/lesson';
import { searchSerializer } from '@/providers/serializers/search/search';

export class SearchAPI {
  private static INSTANCE = new SearchAPI();

  static get instance() {
    return this.INSTANCE;
  }

  private pedagogyNamespace: string = 'gooru-search/rest/v1/pedagogy-search';

  private namespace = 'gooru-search/rest/v2/search';

  private namespaceContentGenerator = 'api/contentgenerator/v1/showcase';

  public fetchLearningMapContents(competencyCode: string) {
    const namespace = this.pedagogyNamespace;
    const endpoint = `${namespace}/learning-maps/standard/${competencyCode}`;
    const headers = http.getTokenHeaders();
    const options = {
      isDisplayCode: true,
    };
    return http.get(endpoint, headers).then((response) => {
      return searchSerializer.serializeLearningMapData(response.data);
    });
  }

  /**
   * @function fetchCollections can used to fetch collection , assessment ,  offline-activity contents.
   * @param term
   * @param params
   */
  public fetchCollections(params: any = {}) {
    const endpoint = `${this.namespace}/scollection`;
    const headers = http.getTokenHeaders();
    const data = Object.assign({
      'q': '*',
      'isCrossWalk': false,
      'start': params.start || 1,
      'length': params.length || 10,
      'flt.collectionType': 'collection',
      'flt.publishStatus': 'published,unpublished',
    }, params);
    return http.get(endpoint, headers, data).then((response) => {
      return searchSerializer.normalizeSearchCollection(response.data);
    });
  }

  /**
   * @function fetchLessons can used to fetch lesson contents.
   * @param term
   * @param params
   */
   public fetchLessons(params: any = {}) {
    const endpoint = `${this.namespace}/lesson`;
    const headers = http.getTokenHeaders();
    const data = Object.assign({
      q: '*',
      start: params.start || 1,
      length: params.length || 10,
    }, params);
    return http.get(endpoint, headers, data).then((response) => {
      return lessonSerializer.normalizeSearchLessons(response.data);
    });
  }


  /**
   * @function fetchResources can used to fetch resources
   * @param term
   */
   public fetchResources(params: any = {}) {
    const endpoint = `${this.namespace}/resource`;
    const headers = http.getTokenHeaders();
    const options = Object.assign({
        'q': '*',
        'isCrossWalk': false,
        'start': params.start || 0,
        'length': params.length || 10,
        'flt.publishStatus': 'published,unpublished',
        'flt.contentFormat': 'resource',
    }, params);
    return http.get(endpoint, headers, options).then((response) => {
        return searchSerializer.nomalizeSearchResources(response.data);
    });
}

/**
 * @function fetchQuestions can used to fetch questions
 * @param term
 */
public fetchQuestions(params: any = {}) {
    const endpoint = `${this.namespace}/resource`;
    const headers = http.getTokenHeaders();
    const options = Object.assign({
        'q': '*',
        'isCrossWalk': false,
        'start': params.start || 0,
        'length': params.length || 10,
        'flt.audience': 'All Students,Teachers',
        'flt.publishStatus': 'published,unpublished',
        'flt.resourceFormat': 'question',
    }, params);
    return http.get(endpoint, headers, options).then((response) => {
        return searchSerializer.normalizeSearchQuestions(response.data);
    });
}

/**
 * @function fetchGeneratorAI can used to fetch generator details.
 * @param data
 */
public fetchGeneratorAI(data: any = {}) {
  const endpoint = `${this.namespaceContentGenerator}/ai/content`;
  const headers = http.getTokenHeaders();
  return http.post(endpoint, headers, data).then((response) => {
    return searchSerializer.normalizeGeneratorAI(response.data.contents);
  }).catch(() => {
    return [];
  });
}

}

export const searchAPI = SearchAPI.instance;
